import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl, MaxLength, Required } from '@hvlng/framework-bff/core';

@JsonObject('KovanHrDiscriminatorDefinitionDetailModel')
export class DiscriminatorDefinitionDetailModel {
    @Required()
    @MaxLength(50)
    @JsonProperty('shortText', String, true)
    shortText: string = null;

    @EmptyControl()
    @Required()
    @MaxLength(250)
    @JsonProperty('longText', String, true)
    longText: string = null;
}
